!function(t,n){"object"==typeof exports&&"undefined"!=typeof module?n(exports):"function"==typeof define&&define.amd?define(["exports"],n):n((t="undefined"!=typeof globalThis?globalThis:t||self).htmlToImage={})}(this,(function(t){"use strict";
function n(t,n,e,r){return new(e||(e=Promise))((function(o,i){function u(t){try{f(r.next(t))}catch(t){i(t)}}function c(t){try{f(r.throw(t))}catch(t){i(t)}}function f(t){var n;t.done?o(t.value):(n=t.value,n instanceof e?n:new e((function(t){t(n)}))).then(u,c)}f((r=r.apply(t,n||[])).next())}))}function e(t,n){var e,r,o,i,u={label:0,sent:function(){if(1&o[0])throw o[1];return o[1]},trys:[],ops:[]};return i={next:c(0),throw:c(1),return:c(2)},"function"==typeof Symbol&&(i[Symbol.iterator]=function(){return this}),i;function c(i){return function(c){return function(i){if(e)throw new TypeError("Generator is already executing.");for(;u;)try{if(e=1,r&&(o=2&i[0]?r.return:i[0]?r.throw||((o=r.return)&&o.call(r),0):r.next)&&!(o=o.call(r,i[1])).done)return o;switch(r=0,o&&(i=[2&i[0],o.value]),i[0]){case 0:case 1:o=i;break;case 4:return u.label++,{value:i[1],done:!1};case 5:u.label++,r=i[1],i=[0];continue;case 7:i=u.ops.pop(),u.trys.pop();continue;default:if(!(o=u.trys,(o=o.length>0&&o[o.length-1])||6!==i[0]&&2!==i[0])){u=0;continue}if(3===i[0]&&(!o||i[1]>o[0]&&i[1]<o[3])){u.label=i[1];break}if(6===i[0]&&u.label<o[1]){u.label=o[1],o=i;break}if(o&&u.label<o[2]){u.label=o[2],u.ops.push(i);break}o[2]&&u.ops.pop(),u.trys.pop();continue}i=n.call(t,u)}catch(t){i=[6,t],r=0}finally{e=o=0}if(5&i[0])throw i[1];return{value:i[0]?i[1]:void 0,done:!0}}([i,c])}}}var r="application/font-woff",o="image/jpeg",i={woff:r,woff2:r,ttf:"application/font-truetype",eot:"application/vnd.ms-fontobject",png:"image/png",jpg:o,jpeg:o,gif:"image/gif",tiff:"image/tiff",svg:"image/svg+xml"};function u(t){var n=function(t){var n=/\.([^./]*?)$/g.exec(t);return n?n[1]:""}(t).toLowerCase();return i[n]||""}function c(t){return-1!==t.search(/^(data:)/)}function f(t,n){return"data:"+n+";base64,"+t}var a,s=(a=0,function(){return a+=1,"u"+("0000"+(Math.random()*Math.pow(36,4)<<0).toString(36)).slice(-4)+a});function l(t){for(var n=[],e=0,r=t.length;e<r;e+=1)n.push(t[e]);return n}function h(t,n){var e=window.getComputedStyle(t).getPropertyValue(n);return parseFloat(e.replace("px",""))}function d(t){return t.toBlob?new Promise((function(n){return t.toBlob(n)})):new Promise((function(n){for(var e=window.atob(t.toDataURL().split(",")[1]),r=e.length,o=new Uint8Array(r),i=0;i<r;i+=1)o[i]=e.charCodeAt(i);n(new Blob([o],{type:"image/png"}))}))}function v(t){return new Promise((function(n,e){var r=new Image;r.onload=function(){return n(r)},r.onerror=e,r.crossOrigin="anonymous",r.decoding="sync",r.src=t}))}function p(t){return n(this,void 0,void 0,(function(){return e(this,(function(n){return[2,Promise.resolve().then((function(){return(new XMLSerializer).serializeToString(t)})).then(encodeURIComponent).then((function(t){return"data:image/svg+xml;charset=utf-8,"+t}))]}))}))}var g={};function m(t,n){var e=function(t){var n=t.replace(/\?.*/,"");return/ttf|otf|eot|woff2?/i.test(n)&&(n=n.replace(/.*\//,"")),n}(t);if(null!=g[e])return g[e];n.cacheBust&&(t+=(/\?/.test(t)?"&":"?")+(new Date).getTime());var r=window.fetch(t).then((function(t){return t.blob().then((function(n){return{blob:n,contentType:t.headers.get("Content-Type")||""}}))})).then((function(t){var n=t.blob,e=t.contentType;return new Promise((function(t,r){var o=new FileReader;o.onloadend=function(){return t({contentType:e,blob:o.result})},o.onerror=r,o.readAsDataURL(n)}))})).then((function(t){var n,e=t.blob;return{contentType:t.contentType,blob:(n=e,n.split(/,/)[1])}})).catch((function(e){var r="";if(n.imagePlaceholder){var o=n.imagePlaceholder.split(/,/);o&&o[1]&&(r=o[1])}var i="Failed to fetch resource: "+t;return e&&(i="string"==typeof e?e:e.message),i&&console.error(i),{blob:r,contentType:""}}));return g[e]=r,r}function w(t,n,e){var r="."+t+":"+n,o=e.cssText?function(t){var n=t.getPropertyValue("content");return t.cssText+" content: '"+n.replace(/'|"/g,"")+"';"}(e):function(t){return l(t).map((function(n){return n+": "+t.getPropertyValue(n)+(t.getPropertyPriority(n)?" !important":"")+";"})).join(" ")}(e);return document.createTextNode(r+"{"+o+"}")}function b(t,n,e){var r=window.getComputedStyle(t,e),o=r.getPropertyValue("content");if(""!==o&&"none"!==o){var i=s();try{n.className=n.className+" "+i}catch(t){return}var u=document.createElement("style");u.appendChild(w(i,e,r)),n.appendChild(u)}}function y(t){return n(this,void 0,void 0,(function(){var n;return e(this,(function(e){return"data:,"===(n=t.toDataURL())?[2,Promise.resolve(t.cloneNode(!1))]:[2,v(n)]}))}))}function P(t,r){return n(this,void 0,void 0,(function(){return e(this,(function(n){return[2,Promise.resolve(t.poster).then((function(t){return m(t,r)})).then((function(n){return f(n.blob,u(t.poster)||n.contentType)})).then((function(t){return v(t)}))]}))}))}function S(t,r){return n(this,void 0,void 0,(function(){return e(this,(function(n){return r instanceof Element?[2,Promise.resolve().then((function(){return function(t,n){var e=window.getComputedStyle(t),r=n.style;r&&(e.cssText?r.cssText=e.cssText:l(e).forEach((function(t){r.setProperty(t,e.getPropertyValue(t),e.getPropertyPriority(t))})))}(t,r)})).then((function(){return function(t,n){b(t,n,":before"),b(t,n,":after")}(t,r)})).then((function(){return function(t,n){t instanceof HTMLTextAreaElement&&(n.innerHTML=t.value),t instanceof HTMLInputElement&&n.setAttribute("value",t.value)}(t,r)})).then((function(){return r}))]:[2,Promise.resolve(r)]}))}))}function x(t,r,o){return n(this,void 0,void 0,(function(){return e(this,(function(i){return o||!r.filter||r.filter(t)?[2,Promise.resolve(t).then((function(t){return function(t,r){return n(this,void 0,void 0,(function(){return e(this,(function(n){return t instanceof HTMLCanvasElement?[2,y(t)]:t instanceof HTMLVideoElement&&t.poster?[2,P(t,r)]:[2,Promise.resolve(t.cloneNode(!1))]}))}))}(t,r)})).then((function(o){return function(t,r,o){var i;return n(this,void 0,void 0,(function(){var n;return e(this,(function(e){var u;return 0===(n=null!=(u=t).tagName&&"SLOT"===u.tagName.toUpperCase()&&t.assignedNodes?l(t.assignedNodes()):l((null!==(i=t.shadowRoot)&&void 0!==i?i:t).childNodes)).length||t instanceof HTMLVideoElement?[2,Promise.resolve(r)]:[2,n.reduce((function(t,n){return t.then((function(){return x(n,o)})).then((function(t){t&&r.appendChild(t)}))}),Promise.resolve()).then((function(){return r}))]}))}))}(t,o,r)})).then((function(n){return S(t,n)}))]:[2,Promise.resolve(null)]}))}))}var E=/url\((['"]?)([^'"]+?)\1\)/g,T=/url\([^)]+\)\s*format\((["'])([^"']+)\1\)/g,C=/src:\s*(?:url\([^)]+\)\s*format\([^)]+\)[,;]\s*)+/g;function R(t){var n=[];return t.replace(E,(function(t,e,r){return n.push(r),t})),n.filter((function(t){return!c(t)}))}function L(t,n,e,r,o){var i=e?function(t,n){if(t.match(/^[a-z]+:\/\//i))return t;if(t.match(/^\/\//))return window.location.protocol+t;if(t.match(/^[a-z]+:/i))return t;var e=document.implementation.createHTMLDocument(),r=e.createElement("base"),o=e.createElement("a");return e.head.appendChild(r),e.body.appendChild(o),n&&(r.href=n),o.href=t,o.href}(n,e):n;return Promise.resolve(i).then((function(t){return o?o(t):m(t,r)})).then((function(t){return"string"==typeof t?f(t,u(n)):f(t.blob,u(n)||t.contentType)})).then((function(e){return t.replace((r=n.replace(/([.*+?^${}()|\[\]\/\\])/g,"\\$1"),new RegExp("(url\\(['\"]?)("+r+")(['\"]?\\))","g")),"$1"+e+"$3");var r})).then((function(t){return t}),(function(){return i}))}function N(t){return-1!==t.search(E)}function k(t,r,o){return n(this,void 0,void 0,(function(){var n;return e(this,(function(e){return N(t)?(n=function(t,n){var e=n.preferredFontFormat;return e?t.replace(C,(function(t){for(;;){var n=T.exec(t)||[],r=n[0],o=n[2];if(!o)return"";if(o===e)return"src: "+r+";"}})):t}(t,o),[2,Promise.resolve(n).then(R).then((function(t){return t.reduce((function(t,n){return t.then((function(t){return L(t,n,r,o)}))}),Promise.resolve(n))}))]):[2,Promise.resolve(t)]}))}))}function A(t,r){return n(this,void 0,void 0,(function(){return e(this,(function(o){return t instanceof Element?[2,Promise.resolve(t).then((function(t){return function(t,r){var o;return n(this,void 0,void 0,(function(){var n;return e(this,(function(e){return(n=null===(o=t.style)||void 0===o?void 0:o.getPropertyValue("background"))?[2,Promise.resolve(n).then((function(t){return k(t,null,r)})).then((function(n){return t.style.setProperty("background",n,t.style.getPropertyPriority("background")),t}))]:[2,Promise.resolve(t)]}))}))}(t,r)})).then((function(t){return function(t,r){return n(this,void 0,void 0,(function(){var n;return e(this,(function(e){return t instanceof HTMLImageElement&&!c(t.src)||t instanceof SVGImageElement&&!c(t.href.baseVal)?(n=t instanceof HTMLImageElement?t.src:t.href.baseVal,[2,Promise.resolve(n).then((function(t){return m(t,r)})).then((function(t){return f(t.blob,u(n)||t.contentType)})).then((function(n){return new Promise((function(e,r){t.onload=e,t.onerror=r,t instanceof HTMLImageElement?(t.srcset="",t.src=n):t.href.baseVal=n}))})).then((function(){return t}),(function(){return t}))]):[2,Promise.resolve(t)]}))}))}(t,r)})).then((function(t){return function(t,r){return n(this,void 0,void 0,(function(){var n,o;return e(this,(function(e){return n=l(t.childNodes),o=n.map((function(t){return A(t,r)})),[2,Promise.all(o).then((function(){return t}))]}))}))}(t,r)}))]:[2,Promise.resolve(t)]}))}))}var I={};function M(t){var n=I[t];if(null!=n)return n;var e=window.fetch(t).then((function(n){return{url:t,cssText:n.text()}}));return I[t]=e,e}function D(t){return n(this,void 0,void 0,(function(){return e(this,(function(n){return[2,t.cssText.then((function(n){var e=n,r=/url\(["']?([^"')]+)["']?\)/g,o=(e.match(/url\([^)]+\)/g)||[]).map((function(n){var o=n.replace(r,"$1");return o.startsWith("https://")||(o=new URL(o,t.url).href),window.fetch(o).then((function(t){return t.blob()})).then((function(t){return new Promise((function(r,o){var i=new FileReader;i.onloadend=function(){e=e.replace(n,"url("+i.result+")"),r([n,i.result])},i.onerror=o,i.readAsDataURL(t)}))}))}));return Promise.all(o).then((function(){return e}))}))]}))}))}function V(t){if(null==t)return[];for(var n=[],e=t.replace(/(\/\*[\s\S]*?\*\/)/gi,""),r=new RegExp("((@.*?keyframes [\\s\\S]*?){([\\s\\S]*?}\\s*?)})","gi");;){if(null===(u=r.exec(e)))break;n.push(u[0])}e=e.replace(r,"");for(var o=/@import[\s\S]*?url\([^)]*\)[\s\S]*?;/gi,i=new RegExp("((\\s*?(?:\\/\\*[\\s\\S]*?\\*\\/)?\\s*?@media[\\s\\S]*?){([\\s\\S]*?)}\\s*?})|(([\\s\\S]*?){([\\s\\S]*?)})","gi");;){var u;if(null===(u=o.exec(e))){if(null===(u=i.exec(e)))break;o.lastIndex=i.lastIndex}else i.lastIndex=o.lastIndex;n.push(u[0])}return n}function H(t){return t.filter((function(t){return t.type===CSSRule.FONT_FACE_RULE})).filter((function(t){return N(t.style.getPropertyValue("src"))}))}function U(t){return n(this,void 0,void 0,(function(){return e(this,(function(r){return[2,new Promise((function(n,e){null==t.ownerDocument&&e(new Error("Provided element is not within a Document")),n(l(t.ownerDocument.styleSheets))})).then((function(t){return function(t){return n(this,void 0,void 0,(function(){var n,r;return e(this,(function(e){return n=[],r=[],t.forEach((function(n){if("cssRules"in n)try{l(n.cssRules).forEach((function(t,e){if(t.type===CSSRule.IMPORT_RULE){var o=e+1,i=M(t.href).then((function(t){return t?D(t):""})).then((function(t){return V(t).forEach((function(t){try{n.insertRule(t,t.startsWith("@import")?o+=1:n.cssRules.length)}catch(n){console.error("Error inserting rule from remote css",{rule:t,error:n})}}))})).catch((function(t){console.error("Error loading remote css",t.toString())}));r.push(i)}}))}catch(o){var e=t.find((function(t){return null==t.href}))||document.styleSheets[0];null!=n.href&&r.push(M(n.href).then((function(t){return t?D(t):""})).then((function(t){return V(t).forEach((function(t){e.insertRule(t,n.cssRules.length)}))})).catch((function(t){console.error("Error loading remote stylesheet",t.toString())}))),console.error("Error inlining remote css file",o.toString())}})),[2,Promise.all(r).then((function(){return t.forEach((function(t){if("cssRules"in t)try{l(t.cssRules).forEach((function(t){n.push(t)}))}catch(n){console.error("Error while reading CSS rules from "+t.href,n.toString())}})),n}))]}))}))}(t)})).then(H)]}))}))}function j(t,r){return n(this,void 0,void 0,(function(){return e(this,(function(n){return[2,U(t).then((function(t){return Promise.all(t.map((function(t){var n=t.parentStyleSheet?t.parentStyleSheet.href:null;return k(t.cssText,n,r)})))})).then((function(t){return t.join("\n")}))]}))}))}function F(t,n){void 0===n&&(n={});var e=n.width||function(t){var n=h(t,"border-left-width"),e=h(t,"border-right-width");return t.clientWidth+n+e}(t),r=n.height||function(t){var n=h(t,"border-top-width"),e=h(t,"border-bottom-width");return t.clientHeight+n+e}(t);return{width:e,height:r}}function B(t,r){return void 0===r&&(r={}),n(this,void 0,void 0,(function(){var o,i,u;return e(this,(function(c){return o=F(t,r),i=o.width,u=o.height,[2,Promise.resolve(t).then((function(t){return x(t,r,!0)})).then((function(t){return function(t,r){return n(this,void 0,void 0,(function(){return e(this,(function(n){return[2,(null!=r.fontEmbedCSS?Promise.resolve(r.fontEmbedCSS):j(t,r)).then((function(n){var e=document.createElement("style"),r=document.createTextNode(n);return e.appendChild(r),t.firstChild?t.insertBefore(e,t.firstChild):t.appendChild(e),t}))]}))}))}(t,r)})).then((function(t){return A(t,r)})).then((function(t){return function(t,n){var e=t.style;n.backgroundColor&&(e.backgroundColor=n.backgroundColor),n.width&&(e.width=n.width+"px"),n.height&&(e.height=n.height+"px");var r=n.style;return null!=r&&Object.keys(r).forEach((function(t){e[t]=r[t]})),t}(t,r)})).then((function(t){return function(t,r,o){return n(this,void 0,void 0,(function(){var n,i,u;return e(this,(function(e){return n="http://www.w3.org/2000/svg",i=document.createElementNS(n,"svg"),u=document.createElementNS(n,"foreignObject"),i.setAttribute("width",""+r),i.setAttribute("height",""+o),i.setAttribute("viewBox","0 0 "+r+" "+o),u.setAttribute("width","100%"),u.setAttribute("height","100%"),u.setAttribute("x","0"),u.setAttribute("y","0"),u.setAttribute("externalResourcesRequired","true"),i.appendChild(u),u.appendChild(t),[2,p(i)]}))}))}(t,i,u)}))]}))}))}var O=16384;function $(t,r){return void 0===r&&(r={}),n(this,void 0,void 0,(function(){return e(this,(function(n){return[2,B(t,r).then(v).then((function(n){var e=document.createElement("canvas"),o=e.getContext("2d"),i=r.pixelRatio||function(){var t,n;try{n=process}catch(t){}var e=n&&n.env?n.env.devicePixelRatio:null;return e&&(t=parseInt(e,10),Number.isNaN(t)&&(t=1)),t||window.devicePixelRatio||1}(),u=F(t,r),c=u.width,f=u.height,a=r.canvasWidth||c,s=r.canvasHeight||f;return e.width=a*i,e.height=s*i,r.skipAutoScale||function(t){(t.width>O||t.height>O)&&(t.width>O&&t.height>O?t.width>t.height?(t.height*=O/t.width,t.width=O):(t.width*=O/t.height,t.height=O):t.width>O?(t.height*=O/t.width,t.width=O):(t.width*=O/t.height,t.height=O))}(e),e.style.width=""+a,e.style.height=""+s,r.backgroundColor&&(o.fillStyle=r.backgroundColor,o.fillRect(0,0,e.width,e.height)),o.drawImage(n,0,0,e.width,e.height),e}))]}))}))}t.getFontEmbedCSS=function(t,r){return void 0===r&&(r={}),n(this,void 0,void 0,(function(){return e(this,(function(n){return[2,j(t,r)]}))}))},t.toBlob=function(t,r){return void 0===r&&(r={}),n(this,void 0,void 0,(function(){return e(this,(function(n){return[2,$(t,r).then(d)]}))}))},t.toCanvas=$,t.toJpeg=function(t,r){return void 0===r&&(r={}),n(this,void 0,void 0,(function(){return e(this,(function(n){return[2,$(t,r).then((function(t){return t.toDataURL("image/jpeg",r.quality||1)}))]}))}))},t.toPixelData=function(t,r){return void 0===r&&(r={}),n(this,void 0,void 0,(function(){var n,o,i;return e(this,(function(e){return n=F(t,r),o=n.width,i=n.height,[2,$(t,r).then((function(t){return t.getContext("2d").getImageData(0,0,o,i).data}))]}))}))},t.toPng=function(t,r){return void 0===r&&(r={}),n(this,void 0,void 0,(function(){return e(this,(function(n){return[2,$(t,r).then((function(t){return t.toDataURL()}))]}))}))},t.toSvg=B,Object.defineProperty(t,"__esModule",{value:!0})}));

const saveModalBtn = document.getElementById('saveModal')
saveModalBtn.addEventListener('click' , (e) => {
    htmlToImage.toJpeg(document.getElementById('reportModal'), { quality: 0.95 })
  .then(function (dataUrl) {
    var link = document.createElement('a');
    var rptFileName = identifier.patient
    link.download = `${rptFileName}.jpeg`;
    link.href = dataUrl;
    link.click();
  });
    console.log(e);
});

const newWorkBtn = document.querySelector("#worksheets-btn");
newWorkBtn.addEventListener("click", (e) => {
  showPatID();
  console.log(e);
});
function showPatID() {
  document.getElementById("patientId").style.display = "block";
}


const togMenuBtn = document.querySelector("#togMenu");

togMenuBtn.addEventListener("click", (e) => {
  myFunction();
  console.log(e);
});
function myFunction() {
  var x = document.getElementById("navDemo");
  if (x.className.indexOf("w3-show") == -1) {
    x.className += " w3-show";
  } else {
    x.className = x.className.replace(" w3-show", "");
  }
}
function printReport() {
  document.getElementById("nonPrintable").className += "noPrint";
  window.print();
}
const printReportBtn = document.querySelector("#printReport");
printReportBtn.addEventListener("click", (e) => {
  printReport();
  console.log(e);
});

function showReportModal() {
  document.getElementById("reportModal").style.display = "block";
}

window.onclick = function (event) {
  if (
    event.target.id == "id01" ||
    event.target.id == "id02" ||
    event.target.id == "id03" ||
    event.target.id == "id04" ||
    event.target.id == "id05" ||
    event.target.id == "reportModal" ||
    event.target.id == "patientId" ||
    event.target.id == "dhrInput"
  ) {
    document.getElementById(event.target.id).style.display = "none";
  }
};
const history = {
    patID : "",
    
    title: "Ultrasound Pelvis",
    lmp : '',
    
    
    symptoms: "",
    custom : '',
    
    
    reportLine :function () {
      history.reportLine = clinReport();
    }
  };
  const identifier =  {
    patient: "",
    sono : "",
  }
  
  function getPatID() {
  
    document.querySelector("#patIdLine").innerHTML = boldString("Patient Identifier  -  ",'Patient Identifier') + identifier.patient
      document.querySelector("#sonoIdLine").innerHTML = boldString('Sonographer  -  ','Sonographer') + identifier.sono;
       
      document.getElementById("patientId").style.display = "none";
    }
    
    const pDSubBtn = document.querySelector("#patDetSub");
    pDSubBtn.addEventListener("click", (e) => {
      
      identifier.patient = document.getElementById('patDet').value;
      identifier.sono = document.getElementById('sono').value;
      getPatID();
      if (imaging.reported === false) {
        document.getElementById('clinPanel').click()
      }
      if (imaging.reported === true && imaging.populated === true) {
         populate();
      }
     
      console.log(e);
    });
  
  
  const hisLmpText = document.querySelector('#hisLmp')
  hisLmpText.addEventListener("focusout", (e) => {
      history.lmp = e.target.value
  }); 
  const hisCusText = document.querySelector('#hisCus')
  hisCusText.addEventListener("focusout", (e) => {
      history.custom = e.target.value
  });

  
  
  
  const hisSymBtn = document.querySelectorAll(".hisSym");
  hisSymBtn.forEach((button) => {
    button.addEventListener("click", (e) => {
      history.symptoms = e.target.id;
      console.log(e);
    });
  });
  
  
  
  
  function histAge() {
    let today = new Date();
    let currentYear = today.getFullYear();
    let birthYear = document.getElementById("birthyear").value;
    history.age = currentYear - birthYear;
    if (history.age < 120 && history.age > 0) {
      return;
    } else
      while (birthYear == undefined || birthYear == NaN) {
        birthYear = window.prompt(
          "Enter the YEAR OF BIRTH for this PATIENT. Enter a value BETWEEN 1900 and 2020."
        );
      }
    if (birthYear != undefined && birthyear != NaN) {
      history.age = currentYear - birthYear;
    }
  }
  
  
  
  function clinReport() {
    
      if (history.lmp !== '') {
        history.reportLine =
        'LMP ' + history.lmp +'.  ' + history.symptoms  + history.custom
      } else {
        history.reportLine =
        history.symptoms  + history.custom
      }
      
  }

  
  function addClin() {
    clinReport();
    document.getElementById("hisRpt").innerHTML = boldString("Clinical Details - ","Clinical Details") + `${history.reportLine}`;
   }
  
   function showDiv(id) {
    var x = document.getElementById(id);
    if (x.className.indexOf("w3-show") == -1) {
      x.className += " w3-show";
    } else { 
      x.className = x.className.replace(" w3-show", "");
    }
  }

function showCDDiv() {
  var x = document.getElementById('clinDet');
  if (x.className.indexOf("w3-show") == -1) {
    x.className += " w3-show";
  } else { 
    x.className = x.className.replace(" w3-show", "");
  }
}
function showUteDiv() {
  var x = document.getElementById('uterus');
  if (x.className.indexOf("w3-show") == -1) {
    x.className += " w3-show";
  } else { 
    x.className = x.className.replace(" w3-show", "");
  }
}
function showFibroidDiv() {
  var x = document.getElementById('fibroids');
  if (x.className.indexOf("w3-show") == -1) {
    x.className += " w3-show";
  } else { 
    x.className = x.className.replace(" w3-show", "");
  }
}
function showROvDiv() {
  var x = document.getElementById('rightOv');
  if (x.className.indexOf("w3-show") == -1) {
    x.className += " w3-show";
  } else { 
    x.className = x.className.replace(" w3-show", "");
  }
}
function showLOvDiv() {
  var x = document.getElementById('leftOv');
  if (x.className.indexOf("w3-show") == -1) {
    x.className += " w3-show";
  } else { 
    x.className = x.className.replace(" w3-show", "");
  }
}
function showRKDiv() {
  var x = document.getElementById('rightkidney');
  if (x.className.indexOf("w3-show") == -1) {
    x.className += " w3-show";
  } else { 
    x.className = x.className.replace(" w3-show", "");
  }
}
function showLKDiv() {
  var x = document.getElementById('leftkidney');
  if (x.className.indexOf("w3-show") == -1) {
    x.className += " w3-show";
  } else { 
    x.className = x.className.replace(" w3-show", "");
  }
}
function showBladderDiv() {
  var x = document.getElementById('bladder');
  if (x.className.indexOf("w3-show") == -1) {
    x.className += " w3-show";
  } else { 
    x.className = x.className.replace(" w3-show", "");
  }
}
function showUreterDiv() {
  var x = document.getElementById('ureter');
  if (x.className.indexOf("w3-show") == -1) {
    x.className += " w3-show";
  } else { 
    x.className = x.className.replace(" w3-show", "");
  }
}
function showPouchDiv() {
  var x = document.getElementById('pouch');
  if (x.className.indexOf("w3-show") == -1) {
    x.className += " w3-show";
  } else { 
    x.className = x.className.replace(" w3-show", "");
  }
}
function showBowelDiv() {
  var x = document.getElementById('bowel');
  if (x.className.indexOf("w3-show") == -1) {
    x.className += " w3-show";
  } else { 
    x.className = x.className.replace(" w3-show", "");
  }
}
function showLymphDiv() {
  var x = document.getElementById('lymph');
  if (x.className.indexOf("w3-show") == -1) {
    x.className += " w3-show";
  } else { 
    x.className = x.className.replace(" w3-show", "");
  }
}

const measure = {
  uteLengthMeas : 0,
  uteWidthMeas : 0,
  uteHeightMeas : 0,
  uteMeasFormatted : '',
  uteVolMeas : 0,
  endThickMeas : 0,
  cerLengthMeas : 0,
  rOvLengthMeas : 0,
  rOvWidthMeas : 0,
  rOvHeightMeas : 0,
  rOvVolMeas : 0,
  rOvMeasFormatted : '',
  lOvLengthMeas : 0,
  lOvWidthMeas : 0,
  lOvHeightMeas : 0,
  lOvVolMeas : 0,
  lOvMeasFormatted : '',
  rightKidMeas : 0,
  leftKidMeas : 0,
  bladderMeas : 0,
  residualMeas : 0,
  residual2Meas : 0,
  jets : '',
   }
const measureText = document.querySelectorAll('.measureText')       
measureText.forEach((element) => {
   element.addEventListener('focusout', function (e) {
   let property = this.id;
   measure[property] = e.target.value;
   assignMeasures(measure);
   applyMeasureFindings();
       console.log(e);
   });
});

function assignMeasures(obj) {
  measure.uteMeasFormatted = `${measure.uteLengthMeas} x ${measure.uteHeightMeas} x ${measure.uteWidthMeas}mm. `;
  measure.rOvMeasFormatted = `${measure.rOvLengthMeas} x ${measure.rOvHeightMeas} x ${measure.rOvWidthMeas}mm. `;
  measure.lOvMeasFormatted = `${measure.lOvLengthMeas} x ${measure.lOvHeightMeas} x ${measure.lOvWidthMeas}mm. `;
  endo.thickness = `${obj.endThickMeas}mm. `;
  cerv.length = `${obj.cerLengthMeas / 10}cm. `
  rightKidney.length = `${obj.rightKidMeas / 10}cm. `;
  leftKidney.length = `${obj.leftKidMeas / 10}cm. `;
  bladder.preVol = `${obj.bladderMeas}ml. `;
  bladder.postVol = `${obj.residualMeas}ml. `;
  bladder.postSecVol = `${obj.residual2Meas}ml. `;
  if (measure.jets === 'y') {
    ureters.jets = " Both ureteric jets demonstrated with colour Doppler.  "
  }
}
function calcUterusVolume(obj) {
  let uterusVol = ((obj.uteLengthMeas / 10) * (obj.uteHeightMeas / 10) * (obj.uteWidthMeas / 10)) * 0.523;
obj.uteVolMeas = uterusVol.toFixed(0);
uterus.volume = `${obj.uteVolMeas}cc. `
if (obj.uteVolMeas > 79) {
  uterus.qualSize = "Bulky. "
}

}
function calcOvaryVolumes(obj) {
  let rightOvaryVol = ((obj.rOvLengthMeas / 10) * (obj.rOvHeightMeas / 10) * (obj.rOvWidthMeas / 10)) * 0.523;
  obj.rOvVolMeas = rightOvaryVol.toFixed(0);
  rightOv.volume = `${obj.rOvVolMeas}cc. `;
  let leftOvaryVol = ((obj.lOvLengthMeas / 10) * (obj.lOvHeightMeas / 10) * (obj.lOvWidthMeas / 10)) * 0.523;
  obj.lOvVolMeas = leftOvaryVol.toFixed(0);
  leftOv.volume = `${obj.lOvVolMeas}cc. `;
}

function rectumCalc(obj) {
  if (obj.rectumMeas > 0) {
    bowel.reported = true;
    bowel.rectum = `Normal rectal diameter, ${obj.rectumMeas}mm. `;
  } if (obj.rectumMeas > 29) {
    bowel.rectum = `Increased rectal diameter, ${obj.rectumMeas}mm. `;
  } 
}

function checkMeasureLimits(obj) {
  if (obj.rightKidMeas > 90 ) {
    rightKidney.impression = 'Normal. ';
  } if (obj.leftKidMeas > 90) {
    leftKidney.impression = 'Normal. ';
}}

function applyMeasureFindings() {
  checkMeasureLimits(measure);
  rectumCalc(measure);
  calcUterusVolume(measure);
  calcOvaryVolumes(measure);
}
const rightKidney = {
  impression : 'Normal. ',
  length : '',
  size : '',
  echo : '',
  thickness : '',
  hydro : '',
  focal : '',
  reportLine : function() {
    rightKidney.reportLine = rightKidneyReport();
  },
};
const rKNormalBtn = document.querySelectorAll(".rKNor");
      rKNormalBtn.forEach((button) => {
          button.addEventListener("click", (e) => {
            rightKidney.impression = e.target.id;
            console.log(e);
          });
        });  
        /*
const rKFocalText = document.querySelector('#rKFocalText')
rKFocalText.addEventListener('focusout', (e) => {
    rightKidney.focal = e.target.value;
    rightKidney.impression = '';
    console.log(e);
  })    */
  const rKDimText = document.querySelector('#rKDimText')
  rKDimText.addEventListener('focusout', (e) => {
      rightKidney.length = e.target.value;
      console.log(e);
    })
    const rKSizeBtn = document.querySelectorAll(".rKSiz");
    rKSizeBtn.forEach((button) => {
        button.addEventListener("click", (e) => {
          rightKidney.size = e.target.id;
          rightKidney.impression = '';
          console.log(e);
        });
      }); 
      const rKEchBtn = document.querySelectorAll(".rKEch");
      rKEchBtn.forEach((button) => {
          button.addEventListener("click", (e) => {
            rightKidney.echo = e.target.id;
            rightKidney.impression = '';
            console.log(e);
          });
        }); 
        const rKThiBtn = document.querySelectorAll(".rKThi");
        rKThiBtn.forEach((button) => {
            button.addEventListener("click", (e) => {
              rightKidney.thickness = e.target.id;
              rightKidney.impression = '';
              console.log(e);
            });
          });
          const rKHydBtn = document.querySelectorAll(".rKHyd");
          rKHydBtn.forEach((button) => {
              button.addEventListener("click", (e) => {
                rightKidney.hydro = e.target.id;
              rightKidney.impression = '';

                console.log(e);
              });
            })
            function rightKidneyReport() {
              rightKidney.reportLine =  rightKidney.length + rightKidney.impression +rightKidney.size + rightKidney.echo+ rightKidney.thickness+ rightKidney.hydro  +rightKidney.focal
              
           }
             function addRightKidney() {
               if (rightKidney.length === '') {
                 return;
               }
               rightKidneyReport();
               document.getElementById("rKRpt").innerHTML = boldString("Right Kidney  -  ","Right Kidney") + rightKidney.reportLine;
             }
//     --------------focal rightKidney -----------------------------------------
const rightKidneyFocalList = [];

let newRightKidneyFocal = rightKidneyFocalList.at(-1);
 let rightRptNumber = rightKidneyFocalList.length;
let newRightKidneyFocalId = `rightKidneyFocalRpt${rightRptNumber}`;


const rightKidneyFocalSubBtn = document.querySelector("#rightKidneyFocalSubBtn");
rightKidneyFocalSubBtn.addEventListener("click", (e) => {
 e.preventDefault();
 rightKidney.impression = '';
 showDiv('rightKidneyFocal');
 addrightKidneyFocal(newRightKidneyFocal);
 subPopulate();
 console.log(e);
});

function addrightKidneyFocalRpt() {
let newRpt = document.createElement('span');
newRpt.setAttribute('id', newRightKidneyFocal.id);
newRpt.classList.add('reportInd');
newRpt.textContent = '';
worksheet.insertBefore(newRpt,lKRpt);
let rKBreak = document.createElement('br');
worksheet.insertBefore(rKBreak,lKRpt);
}


const newRightKidneyFocalBtn = document.getElementById('newRightKidneyFocal');
newRightKidneyFocalBtn.addEventListener('click', () => {
rightKidneyFocalList.push(new rightKidneyFocal);
newRightKidneyFocal = rightKidneyFocalList.at(-1);
newRightKidneyFocal.number = rightKidneyFocalList.length;
newRightKidneyFocal.id = 'rightKidneyFocalRpt' + newRightKidneyFocal.number;
addrightKidneyFocalRpt();
clearTextFields('.rightKidneyFocalText');
showDiv('rightKidneyFocal');

})
function clearTextFields(className) {
  const textNodes = document.querySelectorAll(className);
  textNodes.forEach((element => {
      element.value = '';
  }));
  }; 

const lKRpt = document.getElementById('lKRpt');

class rightKidneyFocal {
 constructor() {
   this.number = '',
   this.id = '',
   this.pole = '';
   this.dimension = '';
   this.features = '';
   this.diagnosis =  '';
   this.diagText = '';
   this.previous = '';
 }
 }

 function addrightKidneyFocal(element) {
     if (element.pole !== '' && element.dimension !== '' && element.diagnosis !== '') {
         document.getElementById(element.id).innerHTML = `${boldString(element.pole +'  -  ',element.pole)} 
     ${element.dimension}  ${element.features} ${element.diagnosis} ${element.diagText} `
     }
     if (element.pole !== '' && element.dimension !== '' && element.diagnosis !== '' && element.previous !== "") {
      document.getElementById(element.id).innerHTML = `${boldString(element.pole +'  -  ',element.pole)} 
      ${element.dimension}  ${element.features} ${element.diagnosis} ${element.diagText}${'(Previous - ' + element.previous + ')'} `
     }}
     
const rightKidneyFocalText = document.querySelectorAll('.rightKidneyFocalText')       
rightKidneyFocalText.forEach((element) => {
   element.addEventListener('focusout', function (e) {
   let property = this.dataset.prop;
   newRightKidneyFocal[property] = e.target.value;
       console.log(e);
   });
});

const rightKidneyFocalBtn = document.querySelectorAll(".rightKidneyFocalBtn")
rightKidneyFocalBtn.forEach((button) => {
button.addEventListener("click", function  (e)  {
property = this.dataset.prop;
  newRightKidneyFocal[property] = e.target.id;
  console.log(e);
})
})  
     // ------------------------------end of focal rightKidney --------------------------                  

             /*
             const rKRptBtn = document.querySelector("#rightKidRep");
           rKRptBtn.addEventListener("click", () => {
                 
                 addRightKidney();
                 showReportModal();
               });
*/
               const leftKidney = {
                impression : 'Normal. ',
                length : '',
                size : '',
                echo : '',
                thickness : '',
                hydro : '',
                focal : '',
                reportLine : function() {
                  leftKidney.reportLine = leftKidneyReport();
                },
              };
              /*
              const lKFocalText = document.querySelector('#lKFocalText')
              lKFocalText.addEventListener('focusout', (e) => {
                  leftKidney.focal = e.target.value;
                  leftKidney.impression = '';
                  console.log(e);
                }) */
                const lKDimText = document.querySelector('#lKDimText')
                lKDimText.addEventListener('focusout', (e) => {
                    leftKidney.length = e.target.value;

                    console.log(e);
                  })
    const lKSizeBtn = document.querySelectorAll(".lKSiz");
    lKSizeBtn.forEach((button) => {
        button.addEventListener("click", (e) => {
          leftKidney.size = e.target.id;
          leftKidney.impression = '';
          console.log(e);
        });
      });
      const lKNormalBtn = document.querySelectorAll(".lKNor");
      lKNormalBtn.forEach((button) => {
          button.addEventListener("click", (e) => {
            leftKidney.impression = e.target.id;
            console.log(e);
          });
        });  
      const lKEchBtn = document.querySelectorAll(".lKEch");
      lKEchBtn.forEach((button) => {
          button.addEventListener("click", (e) => {
            leftKidney.echo = e.target.id;
            leftKidney.impression = '';
            console.log(e);
          });
        }); 
        const lKThiBtn = document.querySelectorAll(".lKThi");
        lKThiBtn.forEach((button) => {
            button.addEventListener("click", (e) => {
     leftKidney.thickness = e.target.id;
     leftKidney.impression = '';
     console.log(e);
   });
 });
 const lKHydBtn = document.querySelectorAll(".lKHyd");
 lKHydBtn.forEach((button) => {
     button.addEventListener("click", (e) => {
       leftKidney.hydro = e.target.id;
       leftKidney.impression = '';
       console.log(e);
     });
   })
   function leftKidneyReport() {
     leftKidney.reportLine =  leftKidney.length +leftKidney.impression +leftKidney.size + leftKidney.echo+ leftKidney.thickness+ leftKidney.hydro  +leftKidney.focal
     
  }
    function addLeftKidney() {
      if (leftKidney.length === '') {
        return
      }
      leftKidneyReport();
      document.getElementById("lKRpt").innerHTML = boldString("Left Kidney  -  ","Left Kidney") + leftKidney.reportLine;
    }


//     --------------focal leftKidney -----------------------------------------
const leftKidneyFocalList = [];

let newLeftKidneyFocal = leftKidneyFocalList.at(-1);
let leftRptNumber = leftKidneyFocalList.length;
let newLeftKidneyFocalId = 'leftKidneyFocalRpt' + leftRptNumber;


const leftKidneyFocalSubBtn = document.querySelector("#leftKidneyFocalSubBtn");
leftKidneyFocalSubBtn.addEventListener("click", (e) => {
 e.preventDefault();
 leftKidney.impression = '';
 showDiv('leftKidneyFocal');
 addleftKidneyFocal(newLeftKidneyFocal);
 subPopulate();
 console.log(e);
});

function addleftKidneyFocalRpt() {
let newRpt = document.createElement('span');
newRpt.setAttribute('id', newLeftKidneyFocal.id);
newRpt.classList.add('reportInd');
newRpt.textContent = '';
worksheet.insertBefore(newRpt,blaRpt);
let lKBreak = document.createElement('br');
worksheet.insertBefore(lKBreak,blaRpt);
}


const newLeftKidneyFocalBtn = document.getElementById('newLeftKidneyFocal');
newLeftKidneyFocalBtn.addEventListener('click', () => {
leftKidneyFocalList.push(new leftKidneyFocal);
newLeftKidneyFocal = leftKidneyFocalList.at(-1);
newLeftKidneyFocal.number = leftKidneyFocalList.length;
newLeftKidneyFocal.id = 'leftKidneyFocalRpt' + newLeftKidneyFocal.number;
addleftKidneyFocalRpt();
clearTextFields('.leftKidneyFocalText');
showDiv('leftKidneyFocal');

})


const blaRpt = document.getElementById('blaRpt');

class leftKidneyFocal {
 constructor() {
   this.number = '',
   this.id = '',
   this.pole = '';
   this.dimension = '';
   this.features = '';
   this.diagnosis =  '';
   this.diagText = '';
   this.previous = '';
 }
 }

 function addleftKidneyFocal(element) {
     if (element.pole !== '' && element.dimension !== '' && element.diagnosis !== '') {
         document.getElementById(element.id).innerHTML = `${boldString(element.pole +'  -  ',element.pole)} 
     ${element.dimension} ${element.features} ${element.diagnosis} ${element.diagText} `
     }
     if (element.pole !== '' && element.dimension !== '' && element.diagnosis !== '' && element.previous !== "") {
      document.getElementById(element.id).innerHTML = `${boldString(element.pole +'  -  ',element.pole)} 
      ${element.dimension}  ${element.features} ${element.diagnosis} ${element.diagText}${'(Previous - ' + element.previous + ')'} `
     }}
     
const leftKidneyFocalText = document.querySelectorAll('.leftKidneyFocalText')       
leftKidneyFocalText.forEach((element) => {
   element.addEventListener('focusout', function (e) {
   let property = this.dataset.prop;
   newLeftKidneyFocal[property] = e.target.value;
       console.log(e);
   });
});

const leftKidneyFocalBtn = document.querySelectorAll(".leftKidneyFocalBtn")
leftKidneyFocalBtn.forEach((button) => {
button.addEventListener("click", function  (e)  {
property = this.dataset.prop;
  newLeftKidneyFocal[property] = e.target.id;
  console.log(e);
})
})  
     // ------------------------------end of focal leftKidney -------------------------- 



 const bladder = {
  preVol : '',
  postVol : '',
  postSecVol : '',
  wall : 'Normal wall thickness. ',  
  focal : 'No focal mucosal lesion. ',
  reportLine : function() {
    bladder.reportLine = bladderReport();
  },
};
const blaPreVolText = document.querySelector('#blaPreVolText')
blaPreVolText.addEventListener('focusout', (e) => {
    bladder.preVol = e.target.value;
    console.log(e);
  })
  const blaPostVolText = document.querySelector('#blaPostVolText')
  blaPostVolText.addEventListener('focusout', (e) => {
      bladder.postVol = e.target.value;
      console.log(e);
    })
    const blaSecVolText = document.querySelector('#blaSecVolText')
    blaSecVolText.addEventListener('focusout', (e) => {
      bladder.postSecVol = e.target.value;
      console.log(e);
    })
    const blaWallBtn = document.querySelectorAll(".blaWall");
    blaWallBtn.forEach((button) => {
        button.addEventListener("click", (e) => {
          bladder.wall = e.target.id;
          console.log(e);
        });
      }); 
      const blaFocalText = document.querySelector('#blaFocalText')
      blaFocalText.addEventListener('focusout', (e) => {
          bladder.focal = e.target.value;
          console.log(e);
        })      
   function bladderReport() {
     bladder.reportLine =  bladder.preVol + bladder.wall + bladder.focal    
  } 

residual = {
    reportLine : function() {
        residual.reportLine = residualReport();
    }
}
function residualReport() { 
    residual.reportLine =  bladder.postVol    
 if (bladder.postSecVol === '' || bladder.postSecVol === '0ml. ') {
   return }
     residual.reportLine += 'Second attempt residual ' + bladder.postSecVol 
 }

const ureters = {
    jets : 'Ureteric jets were not visualised with colour Doppler. ',
    focal : '',
    reportLine : function() {
        ureters.reportLine = uretersReport();
      },
}
const ureFocalText = document.querySelector('#ureFocalText')
      ureFocalText.addEventListener('focusout', (e) => {
          ureters.focal = e.target.value;
          console.log(e);
        }) 
        const ureJetBtn = document.querySelectorAll(".ureJet");
        ureJetBtn.forEach((button) => {
            button.addEventListener("click", (e) => {
              ureters.jets = e.target.id;
              console.log(e);
            });
          });
          function uretersReport() {
            ureters.reportLine =  ureters.jets + ureters.focal 
         
       }       
    function addBladder() {
      if (bladder.preVol === '') {
        return 
      } else {
        bladderReport();
        addResidual();
        addUreters();
      document.getElementById("blaRpt").innerHTML = boldString("Bladder  -  ","Bladder") + bladder.reportLine;
    }
      }
      
    function addResidual() {
        residualReport();
        document.getElementById("residualRpt").innerHTML = boldString("Residual volume  -  ","Residual volume") + residual.reportLine;
      }
    function addUreters() {
        uretersReport();
        document.getElementById("ureRpt").innerHTML = boldString("VUJs  -  ","VUJs") + ureters.reportLine;
      }
   
function hideRequired() {
  let required = document.querySelectorAll('.required')
  required.forEach( function (element) {
    element.style.display = 'none';

  })
};

const imaging = {
  mode : '',
  reported : false,
  populated : false,
}
const imaModeBtn = document.querySelectorAll('.imaMod')
imaModeBtn.forEach((button) => {
  button.addEventListener("click", (e) => {
    imaging.mode = e.target.id;
    imaging.reported = true;
    hideRequired();
    if (imaging.populated === true) {
      populate();
    }
    console.log(e);
  });
});
function addImaMode() {
  document.getElementById("imaRpt").innerHTML = boldString("Imaging  -  ","Imaging") + imaging.mode;
}
  const uterus = {
   morph : '',
   position : 'Anteverted ',
   volume : '',
   qualSize : 'Normal volume. ',
   reportLine : function() {
     uterus.reportLine = uteReport();
   },
 };
 function uteReport() {
  uterus.reportLine = measure.uteMeasFormatted + uterus.qualSize +' - '+ uterus.volume + '. ' + uterus.position + uterus.morph
}
function addUterus() {
  uteReport();
  document.getElementById("uteRpt").innerHTML = boldString("Uterus  -  ","Uterus") + uterus.reportLine;
}
const uteMorBtn = document.querySelectorAll(".uteMor");
uteMorBtn.forEach((button) => {
            button.addEventListener("click", (e) => {
              uterus.morph = e.target.id;
              console.log(e);
            });
          });
 const uteQualBtn = document.querySelectorAll(".uteQua");
 uteQualBtn.forEach((button) => {
             button.addEventListener("click", (e) => {
               uterus.qualSize = e.target.id;
               console.log(e);
             });
           });
 const utePosBtn = document.querySelectorAll(".utePos");
utePosBtn.forEach((button) => {
            button.addEventListener("click", (e) => {
              uterus.position = e.target.id;
              console.log(e);
            });
          });
 const uteVolText = document.querySelector('#uteVolText')
uteVolText.addEventListener('focusout', (e) => {
            uterus.volume = e.target.value;
            console.log(e);
          })

const myo = {
    texture : 'Homogeneous. ',
    impression : '',
    focal : '',
    reportLine : function() {
        myometrium.reportLine = myoReport();
      },
}
const myoImpressBtn = document.querySelectorAll(".myoImp");
myoImpressBtn.forEach((button) => {
            button.addEventListener("click", (e) => {
              myo.impression = e.target.id;
              console.log(e);
            });
          });
          

              
const myoTextureBtn = document.querySelectorAll(".myoTex");
myoTextureBtn.forEach((button) => {
            button.addEventListener("click", (e) => {
              myo.texture = e.target.id;
              console.log(e);
            });
          });
function myoReport() {
  myo.reportLine = myo.texture + myo.impression + myo.focal
}
function addMyo() {
  myoReport();
  document.getElementById("myoRpt").innerHTML = boldString("Myometrium  -  ","Myometrium") + myo.reportLine;
}

//     --------------focal fibroid -----------------------------------------
const fibroidFocalList = [];

let newFibroidFocal = fibroidFocalList.at(-1);
 let fibroidRptNumber = fibroidFocalList.length;
let newFibroidFocalId = `fibroidFocalRpt${fibroidRptNumber}`;


const fibroidFocalSubBtn = document.querySelector("#fibroidFocalSubBtn");
fibroidFocalSubBtn.addEventListener("click", (e) => {
 e.preventDefault();
 if (myo.texture = "Homogeneous. ") {
   myo.texture = "Heterogeneous. "
   addMyo();
 }
 imaging.populated = true;
 showDiv('fibroidFocal');
 addFibroidFocal(newFibroidFocal);
 subPopulate();
 console.log(e);
});

function addFibroidFocalRpt() {
let newRpt = document.createElement('span');
newRpt.setAttribute('id', newFibroidFocal.id);
newRpt.classList.add('reportInd');
newRpt.textContent = '';
worksheet.insertBefore(newRpt,endRpt);
let newBreak = document.createElement('br');
worksheet.insertBefore(newBreak,endRpt);
}


const newFibroidFocalBtn = document.getElementById('newFibroidFocal');
newFibroidFocalBtn.addEventListener('click', () => {
fibroidFocalList.push(new fibroidFocal);
newFibroidFocal = fibroidFocalList.at(-1);
newFibroidFocal.number = fibroidFocalList.length;
newFibroidFocal.id = 'fibroidFocalRpt' + newFibroidFocal.number;
addFibroidFocalRpt();
clearTextFields('.fibroidFocalText');
showDiv('fibroidFocal');

})
function clearTextFields(className) {
  const textNodes = document.querySelectorAll(className);
  textNodes.forEach((element => {
      element.value = '';
  }));
  }; 

const endRpt = document.getElementById('endRpt');

class fibroidFocal {
 constructor() {
   this.number = '',
   this.id = '',
   this.side = '';
   this.aspect = '';
   this.level = '';
   this.dimension = '';
   this.features = '';
   this.type =  '';
   this.diagText = '';
   this.previous = '';
   this.formatted = function() {
    this.formatted = formatRpt();
  }
 }
 }
 function formatRpt(obj) {
     if (obj.side !== '' && obj.aspect !== '' && obj.level !== '') {
        obj.formatted = boldString(`${obj.side + obj.aspect + obj.level}  -  ` ,obj.side + obj.aspect + obj.level)
     } else if (obj.side !== '' &&  obj.level !== '') {
         obj.formatted = boldString(`${obj.side + obj.level}  -  ` ,obj.side + obj.level)
     } else if (obj.aspect !== '' && obj.level !== '') {
        obj.formatted = boldString(`${obj.aspect + obj.level}  -  ` ,obj.aspect + obj.level)
     } else if (obj.level !== '') {
        obj.formatted = boldString(`${obj.level}  -  `,obj.level)
     } else {
        obj.formatted = boldString(`Unspecified Location  -  `,`Unspecified Location`)
     }
    } 


 function addFibroidFocal(element) {
     formatRpt(element)
     document.getElementById(element.id).innerHTML = `${element.formatted} ${element.dimension} 
          ${element.features} ${element.type} ${element.diagText}`;
    if (element.previous !== "") {
     document.getElementById(element.id).innerHTML = `${element.formatted} ${element.dimension} 
             ${element.features} ${element.type} ${element.diagText}${'(Previous - ' + element.previous + ')'} `
     }
     
     }
     
const fibroidFocalText = document.querySelectorAll('.fibroidFocalText')       
fibroidFocalText.forEach((element) => {
   element.addEventListener('focusout', function (e) {
   let property = this.dataset.prop;
   newFibroidFocal[property] = e.target.value;
       console.log(e);
   });
});

const fibroidFocalBtn = document.querySelectorAll(".fibroidFocalBtn")
fibroidFocalBtn.forEach((button) => {
button.addEventListener("click", function  (e)  {
property = this.dataset.prop;
  newFibroidFocal[property] = e.target.id;
  console.log(e);
})
})  

const endo = {
    phase : '',
    mirena: '',
    thickness : '',
    margin : '',
    focal : '',
    reportLine : function() {
        endo.reportLine = endReport();
      },
}
function endReport() {
    endo.reportLine = endo.thickness +'  ' + endo.phase +  endo.margin + endo.mirena + endo.focal
}
function addEndo() {
    endReport();
       document.getElementById("endRpt").innerHTML = boldString("Endometrium  -  ","Endometrium") + endo.reportLine;
}
const endMarBtn = document.querySelectorAll(".endMar");
endMarBtn.forEach((button) => {
            button.addEventListener("click", (e) => {
              endo.margin = e.target.id;
              console.log(e);
            });
          });
const endMirenaBtn = document.querySelectorAll(".endMir");
endMirenaBtn.forEach((button) => {
            button.addEventListener("click", (e) => {
              endo.mirena = e.target.id;
              console.log(e);
            });
          });

const endFocText = document.querySelector('#endFocText')
endFocText.addEventListener('focusout', (e) => {
            endo.focal = e.target.value;
            console.log(e);
          })
const endThiText = document.querySelector('#endThiText')
endThiText.addEventListener('focusout', (e) => {
            endo.thickness = e.target.value;
            console.log(e);
          })

const endPhaseBtn = document.querySelectorAll(".endPha");
endPhaseBtn.forEach((button) => {
            button.addEventListener("click", (e) => {
              endo.phase = e.target.id;
              console.log(e);
            });
          });


const cerv = {
    naboth : {
        num : '',
        maxDim : '',
    },
    length : '',
    focal : '',
    reportLine : function() {
        cerv.reportLine = cervReport();
      },
}
const cerNabNumBtn = document.querySelectorAll(".cerNab");
cerNabNumBtn.forEach((button) => {
            button.addEventListener("click", (e) => {
              cerv.naboth.num = e.target.id;
              console.log(e);
            });
          });
const cerNabDimText = document.querySelector('#cerNabDimText')
cerNabDimText.addEventListener('focusout', (e) => {
            cerv.naboth.maxDim = e.target.value;
            console.log(e);
          })
const cerLengText = document.querySelector('#cerLengText')
        cerLengText.addEventListener('focusout', (e) => {
            cerv.length = e.target.value;
            console.log(e);
          })

          const cerFocalText = document.querySelector('#cerFocalText')
          cerFocalText.addEventListener('focusout', (e) => {
              cerv.focal = e.target.value;
              console.log(e);
            })
            function cervReport() {
                cerv.reportLine =  cerv.length + '  ' +cerv.naboth.num + cerv.naboth.maxDim +' '+ cerv.focal
                
             }
               function addCerv() {
                cervReport();
                   document.getElementById("cerRpt").innerHTML = boldString("Cervix  -  ","Cervix") + cerv.reportLine;
                   
               }

const rightOv = {
    volume : '',
    follicle : '',
    phys : {
        type : '',
        dim : '',
        },
    mass : {
      features : '',
      impression : '',
      dimension : '',
    },
    adnexa : {
      mass : '',
      
      dimension : '',
    },
    reportLine : function() {
        rightOv.reportLine = rightOvReport();
      },
    }
    const rOvAdnDimText = document.querySelector('#rOvAdnDimText')
    rOvAdnDimText.addEventListener('focusout', (e) => {
        rightOv.adnexa.dimension = e.target.value;
        console.log(e);
      })
      
    const rOvVolText = document.querySelector('#rOvVolText')
        rOvVolText.addEventListener('focusout', (e) => {
            rightOv.volume = e.target.value;
            console.log(e);
          })
          const rOvPhyDimText = document.querySelector('#rOvPhyDimText')
          rOvPhyDimText.addEventListener('focusout', (e) => {
              rightOv.phys.dim = e.target.value;
              console.log(e);
            })
            const rOvMasDimText = document.querySelector('#rOvMasDimText')
          rOvMasDimText.addEventListener('focusout', (e) => {
              rightOv.mass.dimension = e.target.value;
              console.log(e);
            })
            
          const rightOvFollBtn = document.querySelectorAll(".rOvFol");
          rightOvFollBtn.forEach((button) => {
            button.addEventListener("click", (e) => {
              rightOv.follicle = e.target.id;
              console.log(e);
            });
          });
const rightOvphysTypeBtn = document.querySelectorAll(".rOvPhy");
rightOvphysTypeBtn.forEach((button) => {
button.addEventListener("click", (e) => {
rightOv.phys.type = e.target.id;
console.log(e);
});
});
const rOvMasFeaBtn = document.querySelectorAll(".rOvFea");
rOvMasFeaBtn.forEach((button) => {
button.addEventListener("click", (e) => {
rightOv.mass.features = e.target.id;
console.log(e);
});
});
const rOvMasImpBtn = document.querySelectorAll(".rOvImp");
rOvMasImpBtn.forEach((button) => {
button.addEventListener("click", (e) => {
rightOv.mass.impression = e.target.id;
console.log(e);
});
});
const rOvAdnMasBtn = document.querySelectorAll(".rOvAdnMas");
rOvAdnMasBtn.forEach((button) => {
button.addEventListener("click", (e) => {
rightOv.adnexa.mass = e.target.id;
console.log(e);
});
});
function rightOvReport() {
    rightOv.reportLine =  measure.rOvMeasFormatted + rightOv.volume + '  ' +rightOv.follicle
 }

 const rightOvRptP = document.getElementById('rightOvRptP')
 const rightOvRpt2 = document.getElementById('rightOvRpt2')
 const rightOvRpt3 = document.getElementById('rightOvRpt3')

   function addRightOv() {
    rightOvReport();
       document.getElementById("rightOvRpt").innerHTML = boldString("Right Ovary  -  ","Right Ovary") + rightOv.reportLine;
       if (rightOv.phys.dim !== '') {
         let rightOvBreak = document.createElement('br')
         worksheet.insertBefore(rightOvBreak,rightOvRptP)
         document.getElementById('rightOvRptP').innerHTML = boldString("Functional cyst  -  ","Functional cyst") + rightOv.phys.dim + ' '+ rightOv.phys.type
       }
       if (rightOv.mass.dimension !== '' || rightOv.mass.impression !== '') {
        let rightOvBreak2 = document.createElement('br')
        worksheet.insertBefore(rightOvBreak2,rightOvRpt2)
        document.getElementById("rightOvRpt2").innerHTML = boldString("Mass  -  ","Mass") + rightOv.mass.dimension + rightOv.mass.features +rightOv.mass.impression
       }
       if (rightOv.adnexa.dimension !== '' || rightOv.adnexa.mass !== '') {
        let rightOvBreak3 = document.createElement('br')
        worksheet.insertBefore(rightOvBreak3,rightOvRpt3)
         document.getElementById("rightOvRpt3").innerHTML =  boldString("Adnexa  -  ","Adnexa") + rightOv.adnexa.dimension + rightOv.adnexa.mass
       }
      }
       
   const leftOv = {
    volume : '',
    follicle : '',
    phys : {
        type : '',
        dim : '',
        },
    mass : {
      features : '',
      impression : '',
      dimension : '',
    },
    adnexa : {
      mass : '',
      
      dimension : '',
    },
    reportLine : function() {
        leftOv.reportLine = leftOvReport();
      },
    }
    const lOvAdnDimText = document.querySelector('#lOvAdnDimText')
    lOvAdnDimText.addEventListener('focusout', (e) => {
        leftOv.adnexa.dimension = e.target.value;
        console.log(e);
      })
      
    const lOvVolText = document.querySelector('#lOvVolText')
        lOvVolText.addEventListener('focusout', (e) => {
            leftOv.volume = e.target.value;
            console.log(e);
          })
          const lOvPhyDimText = document.querySelector('#lOvPhyDimText')
          lOvPhyDimText.addEventListener('focusout', (e) => {
              leftOv.phys.dim = e.target.value;
              console.log(e);
            })
            const lOvMasDimText = document.querySelector('#lOvMasDimText')
          lOvMasDimText.addEventListener('focusout', (e) => {
              leftOv.mass.dimension = e.target.value;
              console.log(e);
            })
            
          const leftOvFollBtn = document.querySelectorAll(".lOvFol");
          leftOvFollBtn.forEach((button) => {
            button.addEventListener("click", (e) => {
              leftOv.follicle = e.target.id;
              console.log(e);
            });
          });
const leftOvphysTypeBtn = document.querySelectorAll(".lOvPhy");
leftOvphysTypeBtn.forEach((button) => {
button.addEventListener("click", (e) => {
leftOv.phys.type = e.target.id;
console.log(e);
});
});
const lOvMasFeaBtn = document.querySelectorAll(".lOvFea");
lOvMasFeaBtn.forEach((button) => {
button.addEventListener("click", (e) => {
leftOv.mass.features = e.target.id;
console.log(e);
});
});
const lOvMasImpBtn = document.querySelectorAll(".lOvImp");
lOvMasImpBtn.forEach((button) => {
button.addEventListener("click", (e) => {
leftOv.mass.impression = e.target.id;
console.log(e);
});
});
const lOvAdnMasBtn = document.querySelectorAll(".lOvAdnMas");
lOvAdnMasBtn.forEach((button) => {
button.addEventListener("click", (e) => {
leftOv.adnexa.mass = e.target.id;
console.log(e);
});
});
function leftOvReport() {
    leftOv.reportLine = measure.lOvMeasFormatted + leftOv.volume +'  '+ leftOv.follicle
    
 }
 const leftOvRptP = document.getElementById('leftOvRptP')
 const leftOvRpt2 = document.getElementById('leftOvRpt2')
 const leftOvRpt3 = document.getElementById('leftOvRpt3')

   function addLeftOv() {
    leftOvReport();
       document.getElementById("leftOvRpt").innerHTML = boldString("Left Ovary  -  ","Left Ovary") + leftOv.reportLine;
       if (leftOv.phys.dim !== '') {
         let leftOvBreak = document.createElement('br')
         worksheet.insertBefore(leftOvBreak,leftOvRptP)
         document.getElementById('leftOvRptP').innerHTML = boldString("Functional cyst  -  ","Functional cyst") + leftOv.phys.dim + ' '+ leftOv.phys.type
       }
       if (leftOv.mass.dimension !== '' || leftOv.mass.impression !== '') {
        let leftOvBreak2 = document.createElement('br')
        worksheet.insertBefore(leftOvBreak2,leftOvRpt2)
        document.getElementById("leftOvRpt2").innerHTML = boldString("Mass  -  ","Mass") + leftOv.mass.dimension + leftOv.mass.features +leftOv.mass.impression
       }
       if (leftOv.adnexa.dimension !== '' || leftOv.adnexa.mass !== '') {
        let leftOvBreak3 = document.createElement('br')
        worksheet.insertBefore(leftOvBreak3,leftOvRpt3)
         document.getElementById("leftOvRpt3").innerHTML =  boldString("Adnexa  -  ","Adnexa") + leftOv.adnexa.dimension + leftOv.adnexa.mass
       }
      }

 const pouch = {
     fluid : 'No free fluid in the POD. ',
     mobility : 'Normal mobility of the pelvic structures on dynamic imaging. ',
     focal : '',
     reportLine : function() {
        pouch.reportLine = pouchReport();
      },
 }

     const pouchFocalText = document.querySelector('#pouFocalText')
    pouchFocalText.addEventListener('focusout', (e) => {
         pouch.focal = e.target.value;
         console.log(e);
       })
       const pouchFluidBtn = document.querySelectorAll(".pouFlu");
       pouchFluidBtn.forEach((button) => {
         button.addEventListener("click", (e) => {
           pouch.fluid = e.target.id;
           console.log(e);
         });
       });
       const pouchMobBtn = document.querySelectorAll(".pouMob");
       pouchMobBtn.forEach((button) => {
         button.addEventListener("click", (e) => {
           pouch.mobility = e.target.id;
           console.log(e);
         });
       });
         
       
       function pouchReport() {
         pouch.reportLine =  pouch.fluid + pouch.mobility + pouch.focal
         
      }
        function addPouch() {
          pouchReport();
            document.getElementById("pouchRpt").innerHTML = boldString("POD  -  ","POD") + pouch.reportLine;
          
        }
        
        const bowel = {
          reported : false,
          appendix : 'Appendix was not imaged. ',
          appDim : '',
          other : 'No other bowel abnormality identified. ',
          rectum : '',
          focal : '',
          reportLine : function() {
            bowel.reportLine = bowelReport();
          },
        };
        const bowFocalText = document.querySelector('#bowFocalText')
        bowFocalText.addEventListener('focusout', (e) => {
            bowel.focal = e.target.value;
            bowel.reported = true;
            console.log(e);
          })
          
        const bowOtherBtn = document.querySelectorAll(".bowOth");
        bowOtherBtn.forEach((button) => {
            button.addEventListener("click", (e) => {
              bowel.other = e.target.id;
              bowel.reported = true;
              console.log(e);
            });
          }); 
          
          const bowAppBtn = document.querySelectorAll(".bowApp");
        bowAppBtn.forEach((button) => {
            button.addEventListener("click", (e) => {
              bowel.appendix = e.target.id;
              bowel.reported = true;
              console.log(e);
            });
          }); 
          
          function bowelReport() {
            bowel.reportLine =  bowel.appendix+ bowel.appDim + bowel.rectum + bowel.focal+ bowel.other;
            
         }
           function addBowel() {
             if (bowel.reported === false) {
               return
             }
             bowelReport();
             document.getElementById("bowelRpt").innerHTML = boldString("Bowel  -  ","Bowel") + bowel.reportLine;
           }

           const lymph = {
            normal : 'No pelvic lymphadenopathy seen. ',
            reported : false,
            focal : '',
            reportLine : function() {
              lymph.reportLine = lymphReport();
            },
          };
          const lymFocalText = document.querySelector('#lymFocalText')
          lymFocalText.addEventListener('focusout', (e) => {
              lymph.normal = '';
              lymph.focal = e.target.value;
              lymph.reported = true;
              console.log(e);
            })
            const lymFocalBtn = document.querySelector('#lymNor')
            lymFocalBtn.addEventListener('focusout', (e) => {
                
                lymph.reported = true;
                console.log(e);
              })         
          
            
            function lymphReport() { 
                if (lymph.focal === '') {
                    lymph.reportLine =  lymph.normal
                } else {
                    lymph.reportLine = lymph.focal
                }
              
              
           }
             function addLymph() {
               if (lymph.reported === false) {
                 return
               }
               lymphReport();
               document.getElementById("lymphRpt").innerHTML = boldString("Lymph Nodes -  ","Lymph Nodes") + lymph.reportLine;
             }

function boldString(str, substr) {
    var strRegExp = new RegExp(substr, 'g');
    return str.replace(strRegExp, '<b><i>'+substr+'</i></b>');
  }

  const openWSBtn = document.querySelector("#panRep");
  openWSBtn.addEventListener("click", () => {
    imaging.populated = true;
    populate();
  });
  const reOpenWSBtn = document.querySelector("#savRep");
  reOpenWSBtn.addEventListener("click", () => {
    showReportModal();
  });
  function checkID() {
    if (identifier.patient === '' || identifier.sono === '' ) {
     showPatID();
     
    }
   }
   function subPopulate() {
     checkID();
     if (identifier.patient === '' || identifier.sono === '' ) {
      return;
     }
     addClin();
     if (imaging.reported === false) {
       document.getElementById('clinPanel').click();
       return;
     }
     addImaMode();
     showReportModal();
   }
   
   function populate() {
    checkID();
    if (identifier.patient === '' || identifier.sono === '' ) {
     return;
    }
    addClin();
    if (imaging.reported === false) {
      document.getElementById('clinPanel').click();
      return;
    }
    addImaMode();
    addUterus();
    addMyo();
    addEndo();
    addCerv();
    addRightOv();
    addLeftOv();
    addPouch();
    addRightKidney();
    addLeftKidney();
    addBladder();
    addBowel();
    addLymph();
     showReportModal();
     }

const panels = Array.from(document.getElementsByClassName('w3-panel'));
  panels.forEach((element) =>  {
    element.addEventListener('click',(e) => {
      element.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
        inline: 'start'
    });
      console.log(e);
    })
  });
